require('./cardMovementInstallmentChart.scss');
const PropTypes = require('prop-types');
// @ vendors
const React = require('react');
const PureRenderMixin = require('react-addons-pure-render-mixin');
const classnames = require('classnames');
// @ helpers
const { FormattedText, getLanguage } = require('core/i18n').i18n;
const { toFirstUppercase } = require('utilities/stringHelper');
const { formatAmountObject, getPlainAmountObject } = require('utilities/currencyHelper');
// @ commons
const { OKTable } = require('commonsComponents/OKTable');
const { OKTableRow } = require('commonsComponents/OKTableRow');
const { OKTableCell } = require('commonsComponents/OKTableCell');
const { OneLineSymbolAmount } = require('commonsComponents/oneLineSymbolAmount');
const { LabelDate } = require('commonsComponents/labelDate');
// @ constants
const { LABEL_DATE_TODAY, LABEL_DATE_YESTERDAY } = require('constants/commonsComponents');
const TRANSLATION_KEY_PREFIX = 'cardMovementInstallmentChart-';

class CardMovementInstallmentChart extends React.Component {
    constructor(props) {
        super(props);

        this.shouldComponentUpdate = PureRenderMixin.shouldComponentUpdate.bind(this);
    }

    buildTableBodyRows() {
        const { immInstallments } = this.props;

        return immInstallments.map((installment, index) => {
            const situationFormatted = toFirstUppercase(installment.get('situation'));
            const plainAmountMincaObject = getPlainAmountObject(installment.get('impminca'));
            const plainAmountIncmObject = getPlainAmountObject(installment.get('impmincm'));
            const plainAmountMinObject = getPlainAmountObject(installment.get('impmin3'));
            const plainAmountPendingObject = getPlainAmountObject(installment.get('pendingAmount'));
            const language = getLanguage();

            return (
                <OKTableRow key={'rowData-' + index}>
                    <OKTableCell className="card-movement-installment-chart__cell">
                        <LabelDate
                            date={installment.get('date')}
                            language={language}
                            today={LABEL_DATE_TODAY}
                            yesterday={LABEL_DATE_YESTERDAY}
                        />
                    </OKTableCell>
                    <OKTableCell className="card-movement-installment-chart__cell">
                        {installment.get('numaxsub')}
                    </OKTableCell>
                    <OKTableCell className="card-movement-installment-chart__cell">
                        <OneLineSymbolAmount
                            amountObject={plainAmountMincaObject}
                            language={language}
                            amountObjectFormatted={formatAmountObject(plainAmountMincaObject, true)} />
                    </OKTableCell>
                    <OKTableCell className="card-movement-installment-chart__cell">
                        <OneLineSymbolAmount
                            amountObject={plainAmountIncmObject}
                            language={language}
                            amountObjectFormatted={formatAmountObject(plainAmountIncmObject, true)} />
                    </OKTableCell>
                    <OKTableCell className="card-movement-installment-chart__cell">
                        {situationFormatted}
                    </OKTableCell>
                    <OKTableCell className="card-movement-installment-chart__cell card-movement-installment-chart__cell--right">
                        <OneLineSymbolAmount
                            amountObject={plainAmountMinObject}
                            language={language}
                            amountObjectFormatted={formatAmountObject(plainAmountMinObject, true)} />
                    </OKTableCell>
                    <OKTableCell
                        className="card-movement-installment-chart__cell card-movement-installment-chart__cell--right card-movement-installment-chart__cell--bold"
                    >
                        <OneLineSymbolAmount
                            amountObject={plainAmountPendingObject}
                            language={language}
                            amountObjectFormatted={formatAmountObject(plainAmountPendingObject, true)} />
                    </OKTableCell>
                </OKTableRow>
            );
        });
    }

    buildTableHeader() {
        return [
            'date',
            'installmentNumber',
            'interest',
            'installmentAmount',
            'situation',
            'installmentTotal',
            'pendingCapital'
        ].map((thLabel, index) => {
            const tableHeaderClass = classnames('card-movement-installment-chart__cell-header', {
                'card-movement-installment-chart__cell-header--right': index === 5 || index === 6
            });

            return (
                <OKTableCell asHeader={true} key={`thLabel-${index}`} className={tableHeaderClass}>
                    <FormattedText value={`${TRANSLATION_KEY_PREFIX}${thLabel}`} />
                </OKTableCell>
            );
        });
    }

    render() {
        const tableHeaderFields = this.buildTableHeader();
        const tableBodyRows = this.buildTableBodyRows();

        return (
            <section className="card-movement-installment-chart">
                <div className="card-movement-installment-chart__table">
                    <OKTable id="card-movement-installment-chart-0">
                        <thead>
                            <OKTableRow asHeader={true}>
                                {tableHeaderFields}
                            </OKTableRow>
                        </thead>
                        <tbody>
                            {tableBodyRows}
                        </tbody>
                    </OKTable>
                </div>
            </section>
        );
    }
}

CardMovementInstallmentChart.propTypes = {
    immInstallments: PropTypes.object.isRequired
};

module.exports = CardMovementInstallmentChart;
